import React from 'react';
import styles from './Grid.module.scss';
import { GridProps } from './Grid.types';

const Grid = (props: GridProps) => {
  const { 
    columns = 1, 
    rows,
    children,
    ...rest 
  } = props;

  return (
    <div 
      {...rest}
      className={styles.grid}
      style={{
        display: 'grid',
        gridTemplateColumns: `repeat(${columns}, 1fr)`,
        gridTemplateRows: rows ? `repeat(${rows}, 1fr)` : undefined,
      }}
    >
      {children}
    </div>
  );
};

export default Grid;